import { Colors, Spacing } from "@constants"
import { StyleSheet } from "react-native"

export const BadgeFormStyles = (isMobile: boolean) =>
  StyleSheet.create({
    separator: {
      width: "90%",
      height: 2,
      backgroundColor: Colors.tagsGray,
      borderRadius: 2,
      marginVertical: Spacing.XL,
    },
    textHoldingInputContainer: {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: Spacing.L,
    },
    titleText: {
      textAlign: "left",
      marginBottom: Spacing.L,
    },
    fieldLabel: {
      textAlign: "left",
      color: Colors.black,
      marginBottom: Spacing.S,
      fontWeight: "600",
    },
    infoBoxTitle: {
      paddingLeft: Spacing.S,
      fontWeight: "bold",
    },
    badgePersonalizationContainer: {
      width: "100%",
      maxWidth: isMobile ? "100%" : 400,
    },
    badgePersonalizationTitle: {
      textAlign: "left",
      marginBottom: Spacing.S,
      fontWeight: "600",
    },
    optionalText: {
      fontStyle: "italic",
      fontWeight: "400",
      color: Colors.darkGrey,
    },
    badgePersonalizationSubtitle: {
      textAlign: "left",
      color: Colors.darkGrey,
      marginBottom: Spacing.L,
      fontSize: 14,
    },
    goBackButton: {
      marginBottom: Spacing.L,
      position: "absolute",
      left: 0,
      top: -55,
    },
    buttonContent: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
    },
    iconContainer: {
      transform: [{ rotate: "180deg" }],
      marginRight: Spacing.S,
    },
    buttonText: {
      width: "100%",
      fontSize: 16,
      fontWeight: "600",
      color: Colors.foodiBlack,
      fontFamily: "manrope-600",
    },
    buttonsContainer: {
      bottom: 0,
      flex: 1,
      flexDirection: "row",
      marginTop: Spacing.XXL,
      justifyContent: "center",
      position: "sticky" as any,
      width: "100%",
      paddingVertical: 12,
      backgroundColor: Colors.white,
      zIndex: 100,
    },
  })
